import { register, renderBookmark } from '../components/modal';

export const [, openBookmarkModal] = register('view/modal', renderBookmark);
